import { h, ComponentChild } from 'preact'

type Props = {
  image?: ComponentChild,
  children: ComponentChild,
  action?: ComponentChild,
  className?: string
}

const SimplePanel = ({ image, children, action, className='' }: Props) => {
  return (
    <div class={`simple-panel ${className}`}>
      {image && <div className='simple-panel__image'>
        {image}
      </div>}
      <div class='simple-panel__text'>
        {children}
      </div>
      {action && <div className='simple-panel__action'>
        {action}
      </div>}
    </div>
  )
}

export default SimplePanel
